import React from 'react';
import styles from '../../../styles/TaskDetails.module.css';
import FileIcon from './FileIcon';
import { getDocumentUrl, handleViewDocument, handleDownloadDocument, Document } from './utils/documentUtils';
import { useNotification } from '../../../contexts/NotificationContext';

interface TaskDocument extends Document {
  id: string;
  filename: string;
  file_type: string;
  file_size: number;
  file_size_display: string;
  document_type: string;
  description: string;
  is_required: boolean;
  uploaded_by: {
    id: string;
    full_name: string;
    email: string;
  };
  uploaded_at: string;
}

interface TaskAttachmentsProps {
  documents: TaskDocument[];
}

const formatDate = (dateString: string | null) => {
  if (!dateString) return 'No deadline set';
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};

const TaskAttachments: React.FC<TaskAttachmentsProps> = ({ documents }) => {
  const notificationService = useNotification();

  if (!documents || documents.length === 0) {
    return null;
  }

  const handleDownload = (doc: TaskDocument) => {
    handleDownloadDocument(doc as Document, notificationService);
  };

  const handleView = (doc: TaskDocument) => {
    handleViewDocument(doc as Document, notificationService, (d: Document) => handleDownload(d as TaskDocument));
  };

  return (
    <div className={styles.attachmentsSection}>
      <h3 className={styles.sectionTitle} style={{ fontSize: '0.9rem', fontWeight: '600', marginTop: '1rem' }}>Attachments</h3>
      <div className={styles.attachmentsList}>
        {documents.map((doc) => {
          console.log('Document data:', {
            id: doc.id,
            title: doc.title,
            filename: doc.filename,
            file_url: doc.file_url,
            file_type: doc.file_type,
            absolute_url: getDocumentUrl(doc)
          });

          return (
            <div key={doc.id} className={styles.attachmentItem}>
              <div className={styles.attachmentIcon}>
                <FileIcon fileType={doc.file_type} filename={doc.filename} />
              </div>
              <div className={styles.attachmentInfo}>
                <div className={styles.attachmentName}>{doc.title}</div>
                <div className={styles.attachmentContent}>{doc.description}</div>
                <div className={styles.attachmentDate}>Added on {formatDate(doc.uploaded_at)}</div>
                {/* Debug info - remove in production */}
                <div style={{ fontSize: '0.75rem', color: '#666', marginTop: '0.25rem' }}>
                  URL: {doc.file_url || 'No URL'}
                </div>
              </div>
              <div className={styles.attachmentActions}>
                <button
                  className={styles.actionBtn}
                  onClick={() => handleView(doc)}
                  title="View document"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                    <circle cx="12" cy="12" r="3" />
                  </svg>
                </button>
                <button
                  className={styles.actionBtn}
                  onClick={() => handleDownload(doc)}
                  title="Download document"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                    <polyline points="7,10 12,15 17,10" />
                    <line x1="12" y1="15" x2="12" y2="3" />
                  </svg>
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TaskAttachments;

